<template>
    <div class="pricing-plan-cards-section">
        <div class="col-lg-12 pricing-card-section">
            <div class="pricing-card">
                <h2>Proficiat! U kan nu starten met de App!</h2>
                <div class="row">
                    <div class="col-md-6">
                        <img src="../assets/images/go-to-app.png" height="600px">
                    </div>
                    <div class="col-md-6">
                        <ul>
                            <li class="howto-step"><h2>Installeer de app</h2></li>
                            <li class="howto-step"><h2>Login met uw gegevens</h2></li>
                            <li class="howto-step"><h2>Nodig uw familie uit</h2></li>
                            <li class="howto-step"><h2>Start met het delen</h2></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    data() {
        return {
        }
    },

    methods: {


    }
}
</script>

<style scoped>

.howto-step {
    border: 3px dashed pink;
    list-style-type: none;
    width: 100%;
    height: 130px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>